/* Homepage behavior is independent of Dawn and the PDP custom elements. */
(() => {
  const controllers = new Map();

  function initialize(scope = document) {
    scope.querySelectorAll('[data-home-offers]').forEach((offers) => {
      if (controllers.has(offers)) return;
      const controller = new AbortController();
      const { signal } = controller;
      controllers.set(offers, controller);
      const tiers = [...offers.querySelectorAll('[data-home-tier]')];
      const sticky = offers.querySelector('[data-home-sticky]');
      const tierIndex = Math.max(0, Number(sticky?.dataset.stickyTier || 1) - 1);
      const primary = tiers[tierIndex] || tiers[0];
      const stickyButton = sticky?.querySelector('[data-sticky-submit]');
      const status = offers.querySelector('.home-cart-status');
      let submitting = false;

      function variantAvailable(form) {
        const input = form.querySelector('[data-home-variant]');
        const selected = input?.matches('select') ? input.selectedOptions[0] : input;
        return selected?.dataset.available === 'true';
      }

      function syncSticky() {
        if (!sticky || !primary) return;
        sticky.querySelector('[data-sticky-title]').textContent = primary.querySelector('.pname').textContent;
        sticky.querySelector('[data-sticky-price]').textContent = primary.querySelector('[data-tier-price]').textContent;
        const submit = primary.querySelector('button');
        stickyButton.disabled = submit.disabled || submitting;
      }

      function updateVisibility() {
        if (!sticky || !primary) return;
        const hero = document.querySelector('.hero');
        const rect = offers.getBoundingClientRect();
        const afterHero = !hero || hero.getBoundingClientRect().bottom < 100;
        const offerVisible = rect.top < innerHeight && rect.bottom > 100;
        const visible = afterHero && !offerVisible;
        sticky.classList.toggle('show', visible);
        sticky.inert = !visible;
        document.body.style.setProperty('--home-sticky-height', visible ? `${sticky.offsetHeight}px` : '0px');
      }

      offers.addEventListener('change', (event) => {
        if (!event.target.matches('[data-home-variant]')) return;
        const option = event.target.selectedOptions[0];
        const tier = event.target.closest('[data-home-tier]');
        tier.querySelector('[data-tier-price]').textContent = option.dataset.price;
        const compare = tier.querySelector('[data-tier-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        tier.querySelector('[data-tier-per]').textContent = option.dataset.per;
        const submit = tier.querySelector('button[type="submit"]');
        submit.disabled = option.dataset.available !== 'true';
        submit.textContent = submit.disabled ? submit.dataset.soldLabel : submit.dataset.addLabel;
        syncSticky();
      }, { signal });

      offers.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!form.matches('.home-purchase')) return;
        event.preventDefault();
        if (submitting) return;
        const button = form.querySelector('button[type="submit"]');
        if (button.disabled) return;
        submitting = true;
        button.disabled = true;
        status.textContent = '';
        if (sticky) sticky.querySelector('.home-sticky-status').textContent = '';
        syncSticky();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), signal,
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || offers.dataset.error);
          status.textContent = offers.dataset.added;
          if (sticky) sticky.querySelector('.home-sticky-status').textContent = offers.dataset.added;
          // A successful add stays successful even if the count refresh is unavailable.
          try {
            const cartResponse = await fetch(`${root}cart.js`, { signal });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.querySelectorAll('[data-home-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
            }
          } catch (error) { if (error.name !== 'AbortError') console.debug('Cart count refresh unavailable.'); }
        } catch (error) {
          if (error.name !== 'AbortError') {
            status.textContent = error.message || offers.dataset.error;
            if (sticky) sticky.querySelector('.home-sticky-status').textContent = status.textContent;
          }
        } finally {
          submitting = false;
          if (!signal.aborted) {
            button.disabled = !variantAvailable(form);
            syncSticky();
            updateVisibility();
          }
        }
      }, { signal });

      stickyButton?.addEventListener('click', () => {
        primary?.querySelector('.home-purchase')?.requestSubmit();
      }, { signal });
      window.addEventListener('scroll', updateVisibility, { passive: true, signal });
      window.addEventListener('resize', updateVisibility, { signal });
      syncSticky();
      updateVisibility();
    });
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.home-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    if (event.target.closest('.home-mobile-nav a')) {
      event.target.closest('.home-mobile-nav').open = false;
    }
  });
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches('.home-menu details') || !details.open) return;
    details.closest('.home-menu').querySelectorAll('details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('.home-header details[open]')];
    // All ancestors close, so return focus to the outermost visible trigger.
    const focused = open.find((details) => details.contains(document.activeElement));
    open.forEach((details) => { details.open = false; });
    focused?.querySelector('summary')?.focus();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-home-offers]').forEach((offers) => {
      controllers.get(offers)?.abort();
      controllers.delete(offers);
      document.body.style.removeProperty('--home-sticky-height');
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const dropdown = event.target.closest('.home-menu details') || event.target.querySelector('.home-menu details') || event.target.querySelector('details');
    if (dropdown) dropdown.open = true;
    event.target.scrollIntoView({ block: 'center', behavior: 'instant' });
  });
  initialize();
})();
